export const MODEL_REASONING_SETTINGS = [
    "auto",
    "none",
    "minimal",
    "low",
    "medium",
    "high",
];
/** Compact admin select — skips rarely used `minimal`. */
export const MODEL_REASONING_SELECT_OPTIONS = [
    { value: "auto", label: "Auto (by operation)" },
    { value: "none", label: "Off" },
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
];
export function isModelReasoningSetting(value) {
    return typeof value === "string" && MODEL_REASONING_SETTINGS.includes(value);
}
/**
 * Built-in default when admin has not set an override.
 * Gemini Flash Lite / 2.0 Flash ignore or barely use OpenRouter reasoning, but
 * sending `effort: low` still inflates the fetch timeout (+30s) and made CV
 * generation look stuck. MiniMax M3 thinks internally by default — extra
 * OpenRouter reasoning is what hung tailorCv in production (2026-09-03).
 */
export function builtinModelReasoningSetting(modelId) {
    const id = modelId.toLowerCase();
    if (id.includes("gemini") && (id.includes("flash-lite") || id.includes("2.0-flash"))) {
        return "none";
    }
    if (id.includes("gemma"))
        return "none";
    if (id.includes("minimax-m3"))
        return "none";
    // Haiku 5.5 thinks by default: ~1.9k thinking tokens truncated job evaluations
    // at max_tokens 2048, and effort low still spent ~1.1k (WIN-42).
    if (isDefaultReasoningModel(id))
        return "none";
    return "auto";
}
/**
 * Models that reason when the request carries no `reasoning` field. For them
 * "off" has to be sent explicitly (`reasoning: { enabled: false }`); omitting
 * the field leaves thinking on.
 */
export function isDefaultReasoningModel(modelId) {
    return /claude-haiku-5/.test(modelId.toLowerCase());
}
export function lookupModelReasoningSetting(modelId, effortByModel) {
    const direct = effortByModel?.[modelId];
    if (isModelReasoningSetting(direct))
        return direct;
    const base = modelId.replace(/:free$/, "");
    if (base !== modelId) {
        const baseVal = effortByModel?.[base];
        if (isModelReasoningSetting(baseVal))
            return baseVal;
    }
    return builtinModelReasoningSetting(modelId);
}
//# sourceMappingURL=model-reasoning.js.map